import { apiFetch } from "./client";
import type { Fornitore, ProvaAccessoStato, UtenzaFornitoreInfo } from "@/types";
import type { A2AStatus } from "@/types/admin";

// Nome utente e modalità sono dell'utenza assegnata dall'admin: da qui passano solo
// la password e la chiave (custodite) o il codice (sessione temporanea).
export interface CredenzialiBody { password: string; totp_secret?: string; codice?: string }

const base = "/espo/agenzia/utenze";

export const utenzeApi = {
  lista: () => apiFetch<UtenzaFornitoreInfo[]>(base),
  collega: (f: Fornitore, body: CredenzialiBody) =>
    apiFetch<{ job_id: string }>(`${base}/${f}`, { method: "PUT", body: JSON.stringify(body) }),
  prova: (f: Fornitore, jobId: string) => apiFetch<ProvaAccessoStato>(`${base}/${f}/prova/${jobId}`),
  riaccedi: (f: Fornitore, body: { password: string; codice: string }) =>
    apiFetch<{ job_id: string }>(`${base}/${f}/riaccedi`, { method: "POST", body: JSON.stringify(body) }),
  aggiorna: (f: Fornitore) => apiFetch<Record<string, never>>(`${base}/${f}/aggiorna`, { method: "POST" }),
  inviaDaPratica: (oppId: string) =>
    apiFetch<{ job_id: string }>(`/espo/agenzia/pratiche/${oppId}/invia-fornitore`, { method: "POST" }),
  inviaDaPraticaStatus: (oppId: string, jobId: string) =>
    apiFetch<A2AStatus>(`/espo/agenzia/pratiche/${oppId}/invia-fornitore/${jobId}`),
  async attendiProva(f: Fornitore, jobId: string, opts: { intervalMs?: number; timeoutMs?: number } = {}): Promise<ProvaAccessoStato> {
    const { intervalMs = 1000, timeoutMs = 90_000 } = opts;
    const t0 = Date.now();
    for (;;) {
      const st = await utenzeApi.prova(f, jobId);
      if (st.stato !== "in_corso") return st;
      if (Date.now() - t0 > timeoutMs) return { ...st, stato: "transitorio", dettaglio: "la verifica non si è conclusa in tempo" };
      await new Promise((r) => setTimeout(r, intervalMs));
    }
  },
};
